import { useMemo } from 'react';

import { Region } from 'utils/environment/types';
import { IValidationConfig } from 'utils/form/user-profile-validation-config/types';

export const useFieldIsRequired = (
  region: Region,
  validationConfig: IValidationConfig,
  fieldName: string
) => {
  const fieldIsRequired = useMemo(() => {
    const fieldConfig = Object.entries(validationConfig).find(([key]) => key === fieldName)?.[1];
    const required = fieldConfig?.required;

    if (!required) {
      return false;
    }
    return typeof required === 'boolean' ? required : required.locales.includes(region);
  }, [region, validationConfig, fieldName]);

  return fieldIsRequired;
};
